import React, { PropsWithChildren } from "react";
import styled from "styled-components";
import { botoxColors, colors } from "./colors/color";
import { Label } from "./Label";
import { P } from "./typography/Body";
import { ProgressBar } from "./graphs/ProgressBar";

export function StatCardRow(props:React.PropsWithChildren<{style?: React.CSSProperties}>):JSX.Element
{
    return (
        <StyledStatCardRow style={props.style}>
            {props.children}
        </StyledStatCardRow>
    );
}

type StatCardProps = {
    header?:string,
    subText?: string,
    alignContent?: 'flex-start' | 'center' | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly',
    noTopBorder?: boolean,
    noRightBorder?:boolean,
    noLeftBorder?: boolean,
    noBottomBorder?: boolean,
    bottomBorderRadius?: boolean,
}
export function StatCard(props:PropsWithChildren<StatCardProps>):JSX.Element
{
    return (
        <StyledStatCard bottomBorderRadius={props.bottomBorderRadius || false}
            noTopBorder={props.noTopBorder || false}
            noRightBorder={props.noRightBorder || false}
            noLeftBorder={props.noLeftBorder || false}
            noBottomBorder={props.noBottomBorder || false}>

            {props.header &&
                <Label>{props.header}</Label>
            }
            <div style={{ flex: 1, display:'flex', flexDirection: 'column', justifyContent: props.alignContent ?? 'flex-start' }}>
                {props.children}
            </div>
            {props.subText && (
                <SubText>{props.subText}</SubText>
            )}
        </StyledStatCard>
    );
}

type SimpleStatCardProps = {
    header: string,
    stat: string,
    subText?: string,
    fontSizePx?: number,
};
export function SimpleStatCard(props:SimpleStatCardProps):JSX.Element
{
    return (
        <StatCard header={props.header} subText={props.subText}>
            <SimpleStat fontSizePx={props.fontSizePx ?? 36}>{props.stat}</SimpleStat>
        </StatCard>
    );
}

type StatOutOfStatCardProps = {
    header: string,
    stat: number,
    outOf: number,
    subText?: string
};
export function StatOutOfStatCard(props:StatOutOfStatCardProps):JSX.Element
{
    const safeStat = isNaN(props.stat) ? 0 : props.stat;
    const safeOutOf = isNaN(props.outOf) ? 0 : props.outOf;

    const safeCompletionPct = safeOutOf === 0 ? 0 : (safeStat / safeOutOf) * 100;

    return (
        <StatCard header={props.header} subText={props.subText}>
            <div>
                <span style={{ fontSize: '28px', fontWeight: 500, color: colors.text.normal }}>
                    {safeStat} 
                </span>
                <span style={{ fontSize: '14px', fontWeight: 500, color: colors.text.gray.normal }}>
                    &nbsp;/&nbsp;{safeOutOf}
                </span>
            </div>
            <ProgressBar completionPct={safeCompletionPct} height={10} />
        </StatCard>
    );
}

export const SimpleStat = styled.span<{fontSizePx:number}>`
    color: ${colors.text.normal};
    font-size: ${props => props.fontSizePx}px;
    font-weight: 500;

`;

const SubText = styled(P)`
    font-size: 14px;
`;

const StyledStatCardRow = styled.div`
    display: flex;
    justify-content: stretch;
    background-color: transparent;
`;

const StyledStatCard = styled.div<{noTopBorder:boolean, bottomBorderRadius:boolean, noRightBorder:boolean, noLeftBorder:boolean, noBottomBorder?:boolean}>`
    flex:1;
    display:flex;
    flex-direction: column;
    justify-content: stretch;
    gap: 8px;
    padding: 16px;
    background-color: white;
    border-top: ${props => props.noTopBorder ? 'none' : `1px solid ${botoxColors.border.normal}`};
    border-bottom: ${props => props.noBottomBorder ? 'none' : `1px solid ${botoxColors.border.normal}`};
    border-left: ${props => props.noLeftBorder ? 'none' : `1px solid ${botoxColors.border.normal}`};

    &:first-child {
        border-bottom-left-radius: ${props => props.bottomBorderRadius ? '6px' : '0'};
    }

    &:last-child {
        border-right: ${props => props.noRightBorder ? 'none' : `1px solid ${botoxColors.border.normal}`};
        border-bottom-right-radius: ${props => props.bottomBorderRadius ? '6px' : '0'};
    }
`;